<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        <vs-sidebar click-not-close parent="#forecast-view" :hidden-background="true" class="full-vs-sidebar location-view-sidebar items-no-padding" v-model="isInnerSidebarActive" position-right>
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full" >
                <div class="flex flex-wrap items-center location-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg" v-if="openLocationForecast">
                    <div class="flex mb-4">
                        <div class="flex items-center">
                            <feather-icon icon="XIcon" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                            <h4>{{ openLocationForecast.locationCode }}</h4>
                        </div>
                    </div>
                    <div class="ml-10 mb-4 mt-1">
                        <div class="email__actions--single flex items-baseline">
                           <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-list" vs-icon-off="icon-bar-chart" v-model="isList">
                              <span slot="on"></span>
                              <span slot="off"></span>
                            </vs-switch>
                            <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousLocation')" />
                            <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextLocation')" />
                        </div>
                    </div>
                </div>

                <component :is="scrollbarTag" class="scroll-area-location-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
                  <div v-show="isSidebarActive">
                    <div class="vx-row mb-base" v-show="!isList">
                      <div class="vx-col w-1/3">
                        <vx-card ref="gradeBoxCard" :title="$t('GradeControl.Location.GoldGradeStatistics')">
                          <GradeBoxPlot ref="locationGradeBoxPlot" 
                          :gradeCalculationType="gradeCalculationType">
                          </GradeBoxPlot>
                        </vx-card>
                      </div>
                      <div class="vx-col w-2/3">
                        <vx-card ref="sampleScatterCard" :title="$t('GradeControl.Sample.SampleGoldGrade')">
                            <SamplesScatter ref="sampleScatter"
                             @onUpdateSample="updateSample">
                          </SamplesScatter>
                        </vx-card>
                      </div>
                    </div>
                    <div class="vx-row mb-base" v-show="isList">
                      <div class="vx-col w-full">
                        <vx-card ref="sampleListCard" :title="$t('GradeControl.Sample.SampleList')"  class="list-filters mb-8" title-color="black" >
                          <sample-list-grid
                            ref="sampleListGrid"
                            @onUpdateSample="updateSample">
                          </sample-list-grid>
                        </vx-card>
                      </div>
                    </div>
                  </div>
                </component>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import GradeBoxPlot from "./GradeBoxPlot.vue";
import SampleListGrid from "./SampleListGrid.vue";
import SamplesScatter from "./SamplesScatter.vue";

export default {
  props: {
    openLocationForecast: {
      type: Object
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    gradeCalculationType: {
      type: Number,
      required: true
    },
    displayList: {
      type: Boolean,
      default : false
    }
  },
  components: {
    VuePerfectScrollbar,
    SampleListGrid,
    SamplesScatter,
    GradeBoxPlot
  },
  data () {
    return {
      showThread: false,
      isList: false,
      isInnerSidebarActive: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50
      }
    }
  },
  watch: {
    displayList(val) {
      this.isList = val;
    },
    isSidebarActive (value) {
      this.isInnerSidebarActive = value;
    },
    isInnerSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      } else {
        this.getSamples();
      }
    },
    openLocationForecast (value) {
      if (value) {
        this.getSamples();
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    getSamples() {
      if (this.$props.openLocationForecast) {
        if (this.$refs.sampleListGrid) {
          this.$vs.loading();
          this.$refs.sampleListGrid.getSamplesList(this.$props.openLocationForecast.locationForecastId).then(() => { 
            this.$refs.locationGradeBoxPlot.affectAttributes([this.$props.openLocationForecast]);
            this.$refs.sampleScatter.defineDiagramSettings();
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      }
    },
    updateSample(sample) {
      if (sample) {
        this.$vs.loading();
        // update sample, then refresh location Forecast so that it reflect excluded samples
        this.$store.dispatch("gradeControl/updateSample", sample).then(() => {
          this.$store.dispatch("gradeControl/fetchForecastStats", {
            locationForecastId: this.$props.openLocationForecast.locationForecastId,
            includeHauling: true }).then((result) => {
            this.$refs.locationGradeBoxPlot.affectAttributes([result.data]);
            this.$refs.sampleScatter.defineDiagramSettings();
            this.$emit('onLocationForecastUpdated', result.data);
          });
         
        }).finally(() => this.$vs.loading.close());
      }
    }
  }
}

</script>

